import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { postData } from "../utility/Utility";
import { toast } from "react-toastify";

const WhatsAppModal = ({
  show,
  onClose,
  inquiry,
  onMessageSent,
}) => {
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [selectedMessageType, setSelectedMessageType] = useState("enquiry");

  // Message templates similar to email
  const messageTemplates = {
    enquiry: `Hello ${inquiry?.fullName || 'there'}! Thank you for your inquiry. We'll get back to you soon.`,
    followup: `Hi ${inquiry?.fullName || 'there'}, just following up on your recent inquiry. Do you have any questions?`,
    thankyou: `Thank you ${inquiry?.fullName || 'there'} for reaching out to us! We appreciate your interest.`,
    custom: ""
  };

  // Handle template change
  const handleTemplateChange = (e) => {
    const type = e.target.value;
    setSelectedMessageType(type);
    if (type !== "custom") {
      setMessage(messageTemplates[type]);
    } else {
      setMessage("");
    }
  };

  // Handle message send
  const handleSendMessage = async () => {
    if (!message.trim()) {
      toast.error("Please enter a message");
      return;
    }

    setIsSending(true);
    try {
      // Replace with your actual API endpoint for sending WhatsApp messages
      const response = await postData("api/Whatsapp/message", {
        mobile: inquiry.phoneNumber,
        message: message,
        inquiryId: inquiry._id,
      });

      if (response?.success) {
        toast.success(`WhatsApp message sent to ${inquiry.fullName}`);
        onClose();
        onMessageSent && onMessageSent(inquiry._id);
        setMessage("");
      } else {
        throw new Error(response?.message || "Failed to send message");
      }
    } catch (error) {
      console.error("Error sending WhatsApp message:", error);
      toast.error(error.message || "Failed to send WhatsApp message");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send WhatsApp Message</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>To: {inquiry?.fullName} ({inquiry?.phoneNumber})</Form.Label>
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Label>Message Template</Form.Label>
          <Form.Select 
            value={selectedMessageType} 
            onChange={handleTemplateChange}
            className="mb-3"
          >
            <option value="enquiry">Enquiry Response</option>
            <option value="followup">Follow-up</option>
            <option value="thankyou">Thank You</option>
            <option value="custom">Custom Message</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your WhatsApp message here..."
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSending}>
          Cancel
        </Button>
        <Button 
          variant="success" 
          onClick={handleSendMessage}
          disabled={isSending || !message.trim()}
        >
          {isSending ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Sending...
            </>
          ) : (
            <>
              <i className="mdi mdi-whatsapp me-2"></i>
              Send Message
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WhatsAppModal;
